import format from 'date-fns/format';

const getHourAndMinutes = (date: string) => format(new Date(date), 'H:mm');

export default getHourAndMinutes;
